import React, { useEffect, useRef, useState } from 'react';
import { ScrollTrigger } from '../gsap';
import Player from '@vimeo/player';
import '../styles/eventRecap.scss';
import videoD from '../assets/eventRecap_desktop.mp4';
import videoM from '../assets/eventRecap_mobile.mp4';
import lockup from '../assets/lockup.png';
import close from '../assets/close.svg';

const EventRecap = ({ screenWidth }) => {
  const videoloopRef = useRef();
  const filmRef = useRef();
  const vimeoRef = useRef();
  const videoModalRef = useRef();
  const closeRef = useRef();
  const [showVideo, setShowVideo] = useState(false);

  useEffect(() => {
    ScrollTrigger.create({
      trigger: filmRef.current,
      start: 'top center',
      onEnter: () => {
        videoloopRef.current.play();
      }
    });
  }, []);
  useEffect(() => {
    vimeoRef.current = new Player('video1', {
      id: '779359757',
      controls: true,
      frameborder: '0',
      allow: 'fullscreen; picture-in-picture',
      responsive: true
    });
  }, []);
  useEffect(() => {
    if (showVideo) {
      videoModalRef.current.style.visibility = 'visible';
      closeRef.current.style.visibility = 'visible';
      vimeoRef.current.play();
    } else {
      videoModalRef.current.style.visibility = 'hidden';
      vimeoRef.current.pause();
      closeRef.current.style.visibility = 'hidden';
    }
  }, [showVideo]);
  useEffect(() => {
    vimeoRef.current.on('ended', () => {
      setShowVideo(false);
    });
  }, [setShowVideo]);

  return (
    <div className="eventRecap" id="event">
      <div className="film__videoLoop">
        <video
          muted
          playsInline
          loop
          preload="auto"
          ref={videoloopRef}
          className="film__videoLoop-video"
        >
          {screenWidth > 720 ? (
            <source src={videoD} type="video/mp4" />
          ) : (
            <source src={videoM} type="video/mp4" />
          )}
        </video>
      </div>
      <div className="eventRecap__gradient" />
      <div className="eventRecap__textCont">
        <img src={lockup} alt="" className="eventRecap__textCont__lockup" />
        <div className="eventRecap__textCont__text">
          <p className="small eventRecap--reg">
            On <span className="eventRecap--bold">Wednesday, October 26, 2022</span>, almost 3,000
            visitors from 54 different countries were transported to the distant reaches of our
            known Universe. Using real images from the James Webb Space Telescope, the immersive
            Galaxy Room invited people from all walks of life to imagine themselves as part of the
            next generation of astronauts.
          </p>
          <p className="small eventRecap--reg">
            Times Square was transformed into a pop-up space museum, with Extravehicular Activity
            and Intravehicular Activity suits on display, so guests could learn about the history of
            spacesuit design. Visitors were also given an exclusive first look at The Access I,
            Morgan Stanley’s conceptual model spacesuit, created with the idea that more inclusive
            design can help break down barriers and create access to untapped opportunities.
          </p>
          <p className="small eventRecap-reg">
            <span className="eventRecap--bold">
              Morgan Stanley is committed to creating space for all to participate in the new space
              economy.
            </span>
          </p>
          <button
            id="watchNow2"
            onClick={() => {
              setShowVideo(true);
            }}
          >
            Watch Now
          </button>
        </div>
      </div>
      <img
        className="film__close"
        src={close}
        alt="close video"
        ref={closeRef}
        onClick={() => {
          setShowVideo(false);
        }}
      />
      <div className="film__videoModal" ref={videoModalRef}>
        <div
          className="film__videoModal__vimeo"
          data-vimeo-id="779359757"
          id="video1"
          ref={vimeoRef}
        />
      </div>
    </div>
  );
};

export default EventRecap;
